import { ReactNode, useContext } from "react";
import { useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router-dom";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { DashboardPaymentActiveViewEnum, DashboardServiceActiveViewEnum } from "@monorepo/types";
import { IMiscSliceState } from "@monorepo/types";
import { Box } from "@mui/material";

import { ViewportContext } from "../ViewportContextProvider/ViewportContextProvider";
import { ContextMenu, Main, Menu, Wrapper } from "./DashboardLayout.styles";

export const DashboardLayout = ({
  menu,
  header,
  context,
  hideContextMenu,
  children,
}: {
  menu?: ReactNode;
  header?: ReactNode;
  context?: ReactNode;
  hideContextMenu?: boolean;
  children?: ReactNode;
  activePaymentView?: DashboardPaymentActiveViewEnum;
  activeServiceView?: DashboardServiceActiveViewEnum;
}) => {
  const { pathname } = useLocation();
  const { isMobile } = useContext(ViewportContext);
  const secondaryBg = matchPath(pathname, [
    routeConfig.dashboard.order.mip,
    routeConfig.dashboard.order.cash,
    routeConfig.dashboard.notifications.self,
    routeConfig.dashboard.notifications.notification.self,
    routeConfig.dashboard.payments.paymentOverview,
    routeConfig.dashboard.help.faqGroup.self,
    routeConfig.dashboard.help.self,
    routeConfig.dashboard.profile.personal,
    routeConfig.dashboard.profile.campaign,
    routeConfig.dashboard.profile.settings,
    routeConfig.dashboard.profile.agreements,
    routeConfig.dashboard.profile.codeChange,
    routeConfig.dashboard.profile.app,
  ]);

  const hasMobilePopUp = useSelector(({ miscSlice }: IMiscSliceState) => miscSlice.mobilePopUp);

  return (
    <Wrapper hasMenu={!!menu} isMobile={isMobile}>
      {isMobile ? (
        <>
          {header}
          {context && !hideContextMenu ? (
            <ContextMenu isMobile={true}>{context}</ContextMenu>
          ) : (
            <Main isMobile={true} hasMobilePopUp={!!hasMobilePopUp} secondaryBg={!!secondaryBg}>
              {children || null}
            </Main>
          )}
          {/* Main Menu */}
          {menu && <Menu isMobile={true}>{menu}</Menu>}
        </>
      ) : (
        <>
          {/* Main Menu */}
          {menu && <Menu>{menu}</Menu>}

          {/* Context Menu */}
          {context && <ContextMenu>{context}</ContextMenu>}

          {/* Content */}
          <Main secondaryBg={!!secondaryBg}>
            {header}
            <Box sx={{ overflowY: "auto", overflowX: "hidden" }}>{children || null}</Box>
          </Main>
        </>
      )}
    </Wrapper>
  );
};
